
import React from 'react';
import * as PIXI from 'pixi.js';

// Loads page resources through the shared PIXI.loader.
// - skips resources already in the cache (resource-loader THROWS on
//   duplicate add(), which the old try/catch silently swallowed, and a
//   fully-cached second visit then never received a 'complete' event,
//   leaving the page blank)
// - calls back immediately when there is nothing to load
// ponytail: string filter also drops non-url entries some pages pass in
export const loadPageResources = (resources, onComplete) => {
    const missing = resources.filter((r) => typeof r === 'string' && !PIXI.loader.resources[r]);
    for (const r of missing) {
        PIXI.loader.add(r, r);
    }
    if (missing.length === 0) {
        // deferred: pages call loadResources from their constructor, and a
        // synchronous setState on a not-yet-mounted instance is dropped by React
        setTimeout(() => onComplete(PIXI.loader, PIXI.loader.resources), 0);
        return;
    }
    PIXI.loader.once('complete', onComplete);
    PIXI.loader.load();
};

// Removes stage children and disposes DragonBones armature displays so they
// stop ticking in the global WorldClock. Without dispose() every navigation
// leaks skeletons that advance every frame, forever.
export const clearStage = (app) => {
    const stage = app.stage;
    // snapshot: dispose() removes the child from stage.children mid-loop
    const children = stage.children.slice();
    for (let i = 0; i < children.length; i++) {
        const child = children[i];
        if (child && typeof child.dispose === 'function') {
            child.dispose();
        }
    }
    stage.removeChildren();
};

export const delayUnmounting = (Component) => {
    return class extends React.Component {
        state = {
            shouldRender: this.props.isMounted
        };

        componentDidUpdate(prevProps) {

            setTimeout(
                () => this.setState({shouldRender: true}),
                this.props.delayTime

            );
        }

        render() {
            console.log(this.props);
            return this.state.shouldRender ? <Component {...this.props} /> : null;
        }
    };
}


// WEBPACK FOOTER //
// ./src/Helpers.js